import type { Vault } from '@/types/vault'
import { viemChains } from '@vaultsfyi/common/constants'
import { getNetworkFromChainId } from '@vaultsfyi/common/utils'

export function getExplorerLink(network: Vault['network']['name']): string | null {
  const link = viemChains[network].blockExplorers?.default.url
  if (!link) {
    return null
  }
  return link
}

export function getExplorerName(network: Vault['network']['name']): string | null {
  const name = viemChains[network].blockExplorers?.default.name
  if (!name) {
    return null
  }
  return name
}

export function getExplorerLinkFromAssetCaip(assetCaip: string): string | null {
  const match = /^eip155:(\d+)\//.exec(assetCaip)
  if (!match) return null

  const chainId = Number(match[1])
  if (!Number.isSafeInteger(chainId)) return null

  const network = getNetworkFromChainId(chainId)
  return network ? getExplorerLink(network) : null
}
